<template>
    <header class="header header--fixed" v-scroll="fixedScroll">
        <!-- S: body -->
        <div class="header__body">
            <v-container>
                <h1 class="header__logo">
                    <router-link to="/en" title="Go to Home"><span class="d-sr-only">SAGE LAW</span></router-link>
                </h1>
                <div class="header__contents">
                    <div class="header__gnb">
                        <!-- S: Gnb -->
                        <client-gnb className="gnb" />
                        <!-- E: Gnb -->
                    </div>

                    <!-- S: Header Right -->
                    <div class="header-right">
                        <main-header-language lang="en" />

                        <div class="hamburger-btn-pc">
                            <span />
                        </div>
                    </div>
                    <!-- E: Header Right -->
                </div>
            </v-container>
        </div>
        <!-- E: body -->

        <!-- S: hamburger -->
        <div class="hamburger-btn">
            <span></span>
        </div>
        <!-- E: hamburger -->

        <!-- S: Side gnb -->
        <div class="side-gnb-wrap">
            <v-container>
                <client-gnb className="slide-gnb"></client-gnb>
            </v-container>
        </div>
        <!-- E: Side gnb -->
    </header>
</template>

<script>
import ClientGnb from "@/components/client/inc/client-gnb.vue";
import MainHeaderLanguage from "./main-header-language.vue";

export default {
    components: {
        ClientGnb,
        MainHeaderLanguage,
    },
    data() {
        return {
            window: {
                width: 0,
                height: 0,
            },
        };
    },
    mounted() {
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작

        // 전체메뉴 초기화
        pcMenuHide();

        if (this.isDesktop) {
            this.initPcEvent();
        }
        if (this.isMobile) {
            this.initMobileEvent();
        }
    },
    methods: {
        fixedScroll: function () {
            var header = document.querySelector(".header");
            var scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop > 50) {
                header.classList.add("scroll-active");
            } else {
                header.classList.remove("scroll-active");
            }
        },
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // PC
        initPcEvent: function () {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].addEventListener("mouseenter", gnbLiOver);
                lis[i].addEventListener("mouseleave", gnbLiOut);
            }

            var gnb = document.querySelector(".gnb");
            gnb.addEventListener("mouseenter", gnbOver);
            gnb.addEventListener("mouseleave", gnbOut);

            var slideGnbLinks = document.getElementsByClassName("slide-gnb__link");
            for (var i = 0; i < slideGnbLinks.length; i++) {
                slideGnbLinks[i].addEventListener("click", pcMenuHide);
            }

            // // lang
            // var lang = document.querySelector('.lang-wrap');
            // lang.addEventListener('click', langBox);

            // hamburgerBtnPc
            var hamburgerBtnPc = document.querySelector(".hamburger-btn-pc");
            hamburgerBtnPc.addEventListener("click", pcMenuToggle);

            var sideGnbWrap = document.querySelector(".side-gnb-wrap");
            sideGnbWrap.addEventListener("click", pcMenuHide);
        },
        destroyPcEvent: function () {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].removeEventListener("mouseenter", gnbLiOver);
                lis[i].removeEventListener("mouseleave", gnbLiOut);
            }

            var gnb = document.querySelector(".gnb");
            gnb.removeEventListener("mouseenter", gnbOver);
            gnb.removeEventListener("mouseleave", gnbOut);

            var slideGnbLinks = document.getElementsByClassName("slide-gnb__link");
            for (var i = 0; i < slideGnbLinks.length; i++) {
                slideGnbLinks[i].removeEventListener("click", pcMenuHide);
            }

            // // lang
            // var lang = document.querySelector('.lang-wrap');
            // lang.removeEventListener('click', langBox);
            // lang.classList.remove('active');

            // hamburgerBtnPc
            var hamburgerBtnPc = document.querySelector(".hamburger-btn-pc");
            hamburgerBtnPc.removeEventListener("click", pcMenuToggle);
        },
        // Mobile
        initMobileEvent: function () {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector(".hamburger-btn");
            hamburgerBtn.addEventListener("click", mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
            gnbLinkToggle.forEach(function (el) {
                el.addEventListener("click", toggleAccordion);
            });
        },
        destroyMobileEvent: function () {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector(".hamburger-btn");
            hamburgerBtn.removeEventListener("click", mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
            gnbLinkToggle.forEach(function (el) {
                el.removeEventListener("click", toggleAccordion);
            });
        },
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1024;
        },
        isMobile: function () {
            return this.window.width < 1024;
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
        if (this.isDesktop) {
            this.destroyPcEvent();
        }
        if (this.isMobile) {
            this.destroyMobileEvent();
        }
    },
    watch: {
        isDesktop: function () {
            if (this.isDesktop) {
                this.initPcEvent();
            } else {
                this.destroyPcEvent();
            }
        },
        isMobile: function () {
            if (this.isMobile) {
                this.initMobileEvent();
            } else {
                this.destroyMobileEvent();
            }
        },
    },
};

// PC
function gnbLiOver() {
    var headerBg = document.querySelector(".header__bg");
    var gnbSub = this.querySelector(".gnb__sub");

    this.classList.add("active");
    if (gnbSub == null) {
        headerBg.classList.add("none");
    }
}

function gnbLiOut() {
    var headerBg = document.querySelector(".header__bg");
    var gnbSub = this.querySelector(".gnb__sub");

    this.classList.remove("active");
    if (gnbSub == null) {
        headerBg.classList.remove("none");
    }
}
function gnbOver() {
    var header = document.querySelector(".header");
    header.classList.add("menu-active");
}
function gnbOut() {
    var header = document.querySelector(".header");
    header.classList.remove("menu-active");
}
// function langBox() {
//     var lang = document.querySelector('.lang-wrap');
//     lang.classList.toggle('active');
// };
function pcMenuToggle() {
    var HTML = document.querySelector("html");
    var header = document.querySelector(".header");

    header.classList.toggle("pc-menu-on");
    HTML.classList.toggle("pc-menu-hidden");
}
function pcMenuHide() {
    var HTML = document.querySelector("html");
    var header = document.querySelector(".header");

    header.classList.remove("pc-menu-on");
    HTML.classList.remove("pc-menu-hidden");
}

// Mobile
function mobileMenuToggle() {
    var HTML = document.querySelector("html");
    var header = document.querySelector(".header");
    var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");

    header.classList.toggle("mobile-menu-on");
    // HTML.classList.toggle('hidden');

    if (header.classList.contains("mobile-menu-on")) {
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove("active");
        });
    }
}
function toggleAccordion(el) {
    var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
    var targetLi = el.currentTarget.parentNode.classList;
    var target = el.currentTarget;

    el.preventDefault();
    if (targetLi.contains("active")) {
        targetLi.remove("active");
    } else {
        gnbLinkToggle.forEach(function (el) {
            el.parentNode.classList.remove("active");
        });
        targetLi.add("active");
    }
}
</script>

<style lang="scss" scoped>
.theme--light .v-btn {
    font-weight: 400;
}
.theme--light .v-btn--disabled.v-btn {
    color: white !important;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .theme--light .v-btn:not(.v-btn--disabled):hover {
        color: white !important;
    }
}
@media (min-width: 1200px) {
}
</style>
